var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-paint text-theme lg:pt-24 pb-22 lg:pb-44" },
    [
      _c("div", { staticClass: "relative" }, [
        _c("div", { staticClass: "lg:px-ogs-large z-10" }, [
          _c("div", { staticClass: "hidden lg:grid grid-cols-12 gap-x-gs" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-span-4 xl:col-span-6 pt-16 flex flex-col justify-between",
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center font-bold text-sm" },
                  [
                    _c("span", { staticClass: "w-3 text-right" }, [
                      _vm._v(_vm._s(_vm.carouselIndex)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "opacity-75" }, [_vm._v("/")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "w-3 text-left" }, [
                      _vm._v(_vm._s(_vm.data.length)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("Pagination", {
                  on: {
                    next: function ($event) {
                      return _vm.carousel.next()
                    },
                    prev: function ($event) {
                      return _vm.carousel.previous()
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-span-8 xl:col-span-6" }, [
              _c(
                "div",
                { staticClass: "relative h-0 pt-8/12 overflow-hidden" },
                _vm._l(_vm.data, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "absolute inset-0" },
                    [
                      _c("transition", { attrs: { name: "slow-fade" } }, [
                        index === _vm.carouselRealIndex
                          ? _c("picture", [
                              _c("source", {
                                attrs: {
                                  type: "image/webp",
                                  srcSet: item.image[0].webp,
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass:
                                  "absolute top-0 left-0 w-full h-full object-cover",
                                attrs: {
                                  src: item.image[0].url,
                                  alt: item.image[0].title,
                                  loading: "lazy",
                                  width: "1024",
                                  height: 1024 * (8 / 12),
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "carousel",
              staticClass:
                "lg:absolute lg:top-0 lg:inset-x-0 z-20 pb-8 lg:pt-0",
            },
            _vm._l(_vm.data, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "carousel-item relative w-full lg:pt-22",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative py-8 mb-8 lg:py-0 lg:mb-0 min-h-54 sm:min-h-86 flex items-center lg:min-h-0 lg:block",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "absolute w-3/5 h-full top-0 right-0 z-10 lg:hidden",
                        },
                        [
                          _c("picture", [
                            _c("source", {
                              attrs: {
                                type: "image/webp",
                                srcSet: item.image[0].webp,
                              },
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass:
                                "absolute top-0 left-0 w-full h-full object-cover",
                              attrs: {
                                src: item.image[0].url,
                                alt: item.image[0].title,
                                loading: "lazy",
                                width: "1024",
                                height: 1024 * (3 / 5),
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full relative px-ogs-large z-20" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex lg:hidden items-center font-bold text-sm mb-2",
                            },
                            [
                              _c("span", { staticClass: "w-3 text-right" }, [
                                _vm._v(_vm._s(index + 1)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "opacity-75" }, [
                                _vm._v("/"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "w-3 text-left" }, [
                                _vm._v(_vm._s(_vm.data.length)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass:
                                "w-2/3 md:w-1/2 lg:w-full text-2xl sm:text-4xl lg:text-6xl xl:text-7xl leading-tight",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.heading) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  item.body
                    ? _c(
                        "div",
                        { staticClass: "lg:max-w-xl px-ogs-large lg:pt-4" },
                        [
                          _c("p", { staticClass: "text-sm" }, [
                            _vm._v(_vm._s(item.body)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-ogs-large lg:hidden" },
            [
              _c("Pagination", {
                on: {
                  next: function ($event) {
                    return _vm.carousel.next()
                  },
                  prev: function ($event) {
                    return _vm.carousel.previous()
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }